import React from 'react'
import _ from 'lodash'
import { weekdays } from '../../../utils/retailer'

import styles from '../Form.module.css'

export default ({ data, onChangeFactory, disabled }) =>
  <fieldset>
    {weekdays.map(day => {
      const dayShort = day.substring(0, 3)
      return (
        <section key={dayShort}>
          <label className="label">
            {_.capitalize(day)}
          </label>
          <div className="row">
            <div className="col col-2">
              <label className="radio">
                <input
                  type="radio"
                  name={`${day}Group`}
                  value="true"
                  checked={data[`${dayShort}Open`]}
                  onChange={onChangeFactory(`${dayShort}Open`)}
                  disabled={disabled}
                />
                <i />Open
              </label>
            </div>
            <div className="col col-2">
              <label className="radio">
                <input
                  type="radio"
                  name={`${day}Group`}
                  value="false"
                  checked={!data[`${dayShort}Open`]}
                  onChange={onChangeFactory([`${dayShort}Open`])}
                  disabled={disabled}
                />
                <i />Closed
              </label>
            </div>
          </div>
          <div className={`row ${styles.hourRow}`}>
            {['Open', 'To', 'Close'].map(type => {
              if (type === 'To') {
                return <span key={type}>to</span>
              }
              const prefix = `${day}${type}`
              const hourField = `${prefix}Hour`
              const minuteField = `${prefix}Minute`
              const amField = `${prefix}Am`
              return (
                <span className={styles.storeHour} key={type}>
                  <input
                    type="text"
                    placeholder="HH"
                    value={data[hourField]}
                    onChange={onChangeFactory(hourField)}
                    disabled={!data[`${dayShort}Open`] || disabled}
                  />
                  <span className={styles.hourColon}>:</span>
                  <input
                    type="text"
                    placeholder="MM"
                    value={data[minuteField]}
                    onChange={onChangeFactory(minuteField)}
                    disabled={!data[`${dayShort}Open`] || disabled}
                  />
                  <select
                    className={styles.am}
                    value={data[amField]}
                    onChange={onChangeFactory(amField)}
                    disabled={!data[`${dayShort}Open`] || disabled}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </span>
              )
            })}
          </div>
        </section>
      )
    })}
  </fieldset>
